var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.125 10H21.6875V7.14286C21.6875 3.2 18.4675 0 14.5 0C10.5325 0 7.3125 3.2 7.3125 7.14286V10H5.875C4.29375 10 3 11.2857 3 12.8571V27.1429C3 28.7143 4.29375 30 5.875 30H23.125C24.7062 30 26 28.7143 26 27.1429V12.8571C26 11.2857 24.7062 10 23.125 10ZM14.5 22.8571C12.9187 22.8571 11.625 21.5714 11.625 20C11.625 18.4286 12.9187 17.1429 14.5 17.1429C16.0812 17.1429 17.375 18.4286 17.375 20C17.375 21.5714 16.0812 22.8571 14.5 22.8571ZM18.9562 10H10.0437V7.14286C10.0437 4.7 12.0419 2.71429 14.5 2.71429C16.9581 2.71429 18.9562 4.7 18.9562 7.14286V10Z",
    fill: "#808080"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/lock.c59ee0228a17e3f480f8a905c41d9572.svg";
export { ForwardRef as ReactComponent };